import React from 'react';

import { CookieBannerConsentInput } from '@components/CookieBanner';
import ErrorBlock from '@components/ErrorBlock';

import styles from '@css/layout.scss';

import { getTranslation } from '@services/translations';

interface PageFieldProps {
  ballotVersion?: string;
  ballotVersionNotFound?: boolean;
  showBackButtonDisabledMessage?: boolean;
  pageIdxBiggerThanLastShown?: boolean;
  customMessageHandling?: boolean;
  defPgrAction?: string;
  fieldval?: number;
  fieldname?: string;
  nodeId?: string;
  pagerValidationFailed?: boolean;
  pageNumber?: number | unknown;
}

export default function PageField({
  ballotVersion = '0',
  ballotVersionNotFound = false,
  customMessageHandling = false,
  defPgrAction = '',
  fieldname = '',
  fieldval = 0,
  nodeId = '',
  pageIdxBiggerThanLastShown = false,
  pagerValidationFailed = false,
  pageNumber = null,
  showBackButtonDisabledMessage = false
}: PageFieldProps) {
  let ballotVersionNotFoundError;
  let showBackButtonDisabledMessageError;
  let pageIdxBiggerThanLastShownError;
  let pagerValidationFailedError;
  let pageNumberInput;
  let defPgrActionInput;
  let firstError = true;

  if (ballotVersionNotFound) {
    ballotVersionNotFoundError = (
      <ErrorBlock shouldFocus={firstError} text={getTranslation('BALLOT_VERSION_NOT_FOUND')} />
    );
    firstError = false;
  }

  // This error message is covered by a functional test case but it seems not to be in use
  if (showBackButtonDisabledMessage) {
    showBackButtonDisabledMessageError = (
      <ErrorBlock
        shouldFocus={firstError}
        text={getTranslation('showBackButtonDisabledMessageText')}
      />
    );
    firstError = false;
  }

  if (pageIdxBiggerThanLastShown) {
    pageIdxBiggerThanLastShownError = (
      <ErrorBlock shouldFocus={firstError} text={getTranslation('PAGE_IDX_BIGGER_THAN_SHOWN')} />
    );
    firstError = false;
  }

  // customMessageHandling indicates that the TripAdvisorEndPage will show the message by itself
  if (pagerValidationFailed && !customMessageHandling) {
    pagerValidationFailedError = (
      <ErrorBlock shouldFocus={firstError} text={getTranslation('VALIDATION_WARNING_LONG')} />
    );
    firstError = false;
  }

  if (defPgrAction) {
    defPgrActionInput = <input type="hidden" name="defPgrAction" value={defPgrAction} />;
  }

  if (pageNumber !== null) {
    pageNumberInput = <input type="hidden" name="currentPage" value={pageNumber} />;
  }

  return (
    <div className={styles.layoutContainer}>
      {ballotVersionNotFoundError}
      {showBackButtonDisabledMessageError}
      {pageIdxBiggerThanLastShownError}
      {pagerValidationFailedError}

      <input type="hidden" name={fieldname} value={fieldval} />
      <input type="hidden" name="nodeId" value={nodeId} />
      <input type="hidden" name="ballotVer" value={ballotVersion} />
      {pageNumberInput}
      {defPgrActionInput}
      <CookieBannerConsentInput />
    </div>
  );
}
